export const ColorConstants = {
  BLUE_DARK: '#005B9B',
  BLUE_RAUL: '#0076CC',         // Rent Comps Color
  BLUE_60: '#66ADE0',
  BLUE_30: '#B2D5EF',

  CHARCOAL: '#303436',          // Font Color
  CHARCOAL_DARK: '#181A1B',     // Under Construction Color
  CHARCOAL_LIGHT: '#61676B',    // Market Color

  GRAY: '#C9CDCF',
  GRAY_LIGHT: '#E4E6E7',
  GRAY_LIGHTEST: '#F7F6F3',
  GRAY_MEDIUM: '#BBBBBB',
  GRAY_DARK: '#AFB3B6',

  PURPLE: '#92278E',            // Subject Color
  PURPLE_60: '#B54FB5',
  PURPLE_30: '#D29FD2',

  ORANGE: '#F06000',            // Sales Comps Color
  ORANGE_60: '#F6A066',
  ORANGE_30: '#FACFB2',

  BROWN: '#8B6A4D',

  AQUA: '#2EC7C9',
  AQUA_DARK: '#20898b',              // Subamrket Color

  GREEN: '#00CB55',             // Success Color

  GREEN_LIGHT: '#00CB55',
  YELLOW: '#FFC200',            // Warning Color
  RED: '#D31612',               // Error Color
  WHITE: '#FFFFFF',
  TRANSPARENT: '#fafafa',

  ONE_STAR: '#D92A2A',
  FIVE_STAR: '#8BC14E'
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/color-constants.ts